import { ZodSafeParseResult, ZodSafeParseSuccess } from "zod";
import { SafeParseSuccess } from "zod/v3";

export function isValidParse<T>(result: ZodSafeParseResult<T>): result is SafeParseSuccess<T> {
	return result.success;
}

export function getParseData<T>(result: ZodSafeParseSuccess<T>): T {
	return result.data;
}
